// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingScreen_container__1-SQu","icons":"LoadingScreen_icons__2LIpj"};